import { Flex, FormControl, FormLabel, Switch } from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import { getSubscriptions, setSubscriptions, Sport } from "../data/api";
import useAuth from "../hooks/useAuth";

type Props = {
  sport: Sport;
};

const SubscribeSwitch = ({ sport }: Props) => {
  const { token, userDetails } = useAuth();
  const [subscriptionsData, setSubscriptionsData] = useState<number[]>([]);

  useEffect(() => {
    if (token && userDetails.preferred_username && sport.id) {
      getSubscriptions(token, userDetails.preferred_username).then((data) => {
        setSubscriptionsData(data);
      });
    }
  }, [token, userDetails, sport.id]);

  const handleChange = useCallback(() => {
    if (subscriptionsData.includes(sport.id)) {
      setSubscriptions(token, userDetails.preferred_username, {
        sportIds: subscriptionsData.filter((id) => id !== sport.id),
      });
      setSubscriptionsData((prev) => prev.filter((id) => id !== sport.id));
    } else {
      setSubscriptions(token, userDetails.preferred_username, {
        sportIds: [...subscriptionsData, sport.id],
      });
      setSubscriptionsData((prev) => [...prev, sport.id]);
    }
  }, [sport, subscriptionsData, token, userDetails]);

  return (
    <FormControl display="flex" alignItems="center" mb={5}>
      <FormLabel htmlFor="subscribe" mb="0">
        Subscribe to notifications for {sport.title} updates
      </FormLabel>
      <Switch
        id="subscribe"
        onChange={handleChange}
        isChecked={subscriptionsData.includes(sport.id)}
      />
    </FormControl>
  );
};

export default SubscribeSwitch;
